import request from './request';

let refreshingPromise: Promise<{ accessToken: string; refreshToken: string }> | null = null;
let lastRefreshToken: string | null = null;

export const loginApi = async (
  username: string,
  password: string
): Promise<{ accessToken: string; refreshToken: string }> => {
  const form = new URLSearchParams();
  form.append('username', username);
  form.append('password', password);
  const response = await request.post('/api/auth/login', form, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  const data = response?.data;
  if (!data || typeof data !== 'object') {
    throw new Error('登录响应无效');
  }
  const at = (data as any).access_token;
  const rt = (data as any).refresh_token;
  if (!at || !rt) {
    throw new Error('登录响应缺少令牌');
  }
  return { accessToken: at, refreshToken: rt };
};

export const refreshTokenApi = async (
  refreshToken: string
): Promise<{ accessToken: string; refreshToken: string }> => {
  if (refreshingPromise && lastRefreshToken === refreshToken) {
    return refreshingPromise;
  }
  lastRefreshToken = refreshToken;
  const p = (async () => {
    const response = await request.post('/api/auth/refresh', {
      refresh_token: refreshToken,
    });
    const data = response?.data;
    if (!data || typeof data !== 'object') {
      throw new Error('刷新响应无效');
    }
    const at = (data as any).access_token;
    const rt = (data as any).refresh_token;
    if (!at || !rt) {
      throw new Error('刷新响应缺少令牌');
    }
    return { accessToken: at, refreshToken: rt };
  })();
  refreshingPromise = p;
  p.finally(() => { refreshingPromise = null; lastRefreshToken = null; });
  return p;
};
